const {
  adminCall
} = require("./_utils");

module.exports = {
  list: () => adminCall("app.list"),
  draft: ({
    key,
    version
  }) => adminCall("app.draft", {
    key,
    version
  }),
  create: data => adminCall("app.create", data),
  modify: data => adminCall("app.modify", data),
  remove: uid => adminCall("app.remove", {
    uid
  }),
  getSettings: async appUid => adminCall("app.getSettings", { appUid }),
  migrate: data => adminCall("app.migrate", data)
}